import { useUserSwitchAnimationInit } from "@/hooks/use-user-switch-animation-init";
import { FC, PropsWithChildren } from "react";
import UserSwitchContext from "./user-switch-context";
import UserSwitchPlaceholder from "./user-switch-placeholder";

const UserSwitchProvider: FC<PropsWithChildren> = ({ children }) => {
  const userSwitchAnimation = useUserSwitchAnimationInit();
  const { placeholderStatus, showPlaceholder, handleReturnFromPlaceholder } =
    userSwitchAnimation;

  return (
    <UserSwitchContext.Provider value={userSwitchAnimation}>
      {children}
      <UserSwitchPlaceholder
        status={placeholderStatus}
        isVisible={showPlaceholder}
        onReturn={handleReturnFromPlaceholder}
      />
    </UserSwitchContext.Provider>
  );
};

export default UserSwitchProvider;
